var constantsModule =  angular.module('constants',[]);
export default constantsModule.name;